module.exports = __webpack_public_path__ + "static/img/illus-04.3c6f055.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/illus-04.webp
// module id = 105
// module chunks = 0